import React, {Component} from 'react';
import ReactDOM from "react-dom";
import IframeVideo from "../components/iframe-video";

class CTA extends Component {
    render() {

        return (
            <div>
                <a href="#tickets" className="btn-large orange brand-cta waves-effect waves-light">BUY TICKET</a>
            </div>
        )
    }
}

export default CTA;



// WEBPACK FOOTER //
// ./src/components/cta.js